import AppDispatcher from 'AppDispatcher'
import {Actions} from './Constants'

export default {
   write: message => {
      return AppDispatcher.dispatch({
         actionType: Actions.write,
         message
      })
   },
   read: message => {
      return AppDispatcher.dispatch({
         actionType: Actions.read,
         message
      })
   },

   fetch: (resource, query, messages) => {
      return AppDispatcher.dispatch({
         actionType: Actions.fetch,
         resource,
         query,
         messages
      })
   },

   open: (resource, query) => {
      return AppDispatcher.dispatch({
         actionType: Actions.open,
         resource,
         query
      })
   },

   close: (resource, query) => {
      return AppDispatcher.dispatch({
         actionType: Actions.close,
         resource,
         query
      })
   },

   consume: (resource, query, message) => {
      return AppDispatcher.dispatch({
         actionType: Actions.consume,
         resource,
         query,
         message
      })
   },

   clear: () => {
      AppDispatcher.dispatch({
         actionType: Actions.clear
      })

      return null
   }
}



// WEBPACK FOOTER //
// lib/api/message/Actions.js